import {
  CDropdown,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react-pro'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ChangePasswordModal from './ChangePasswordModal'
import { reduxServices } from '../reducers/reduxServices'
import { useAppDispatch } from '../stateStore'

const AppHeaderDropdown = (): JSX.Element => {
  const dispatch = useAppDispatch()
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false)
  const isVendor = localStorage.getItem('isVendor') === 'true'
  const handleLogout = () => {
    localStorage.clear()
    sessionStorage.clear()
    dispatch(reduxServices.authentication.actions.clearAuthentication())
    dispatch(reduxServices.app.actions.setReRenderMenu(true))
    window.location.reload()
  }

  const handleChangePassword = () => {
    setShowChangePasswordModal(true)
  }

  const handleCloseModal = () => {
    setShowChangePasswordModal(false)
  }
  const dropdownToggleProps = {
    placement: 'bottom-end',
    caret: false,
  }
  const dropdownMenuProps = {
    className: 'p-0',
    placement: 'bottom-end',
  }

  return (
    <>
      <CDropdown
        variant="nav-item"
        data-testid="notification-button"
        className="notification"
      >
        <CDropdownToggle {...dropdownToggleProps}>
          <i className="fa fa-bell-o fa-lg"></i>
        </CDropdownToggle>
        <CDropdownMenu className="py-1 px-2">
          <Link to={'/notifications'} className="dropdown-item text-muted">
            You have messages.
          </Link>
          <CDropdownDivider />
          <Link to={'/notifications'} className="dropdown-item">
            Show All Notifications
            <i className="fa fa-angle-right fa-lg pull-right"></i>
          </Link>
        </CDropdownMenu>
      </CDropdown>
      <CDropdown variant="nav-item" data-testid="logout-button">
        <CDropdownToggle {...dropdownToggleProps}>
          <i className="fa fa-power-off fa-lg"></i>
        </CDropdownToggle>
        <CDropdownMenu {...dropdownMenuProps}>
          {isVendor && (
            <CDropdownItem
              className="cursor-pointer"
              onClick={handleChangePassword}
            >
              Change Password
            </CDropdownItem>
          )}

          <CDropdownItem className="cursor-pointer" onClick={handleLogout}>
            Logout
          </CDropdownItem>
        </CDropdownMenu>
      </CDropdown>

      <ChangePasswordModal
        visible={showChangePasswordModal}
        onClose={handleCloseModal}
      />
    </>
  )
}

export default AppHeaderDropdown
